import script from "./UserName.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserName.vue?vue&type=script&setup=true&lang=ts"

import "./UserName.vue?vue&type=style&index=0&id=1621fb88&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1621fb88"]])

export default __exports__